import { useMemo } from 'react';

import { formatNumber, type FormatNumberOptions } from './formatNumber';
import { useLocaleStore } from '@/stores/locale';

export const useFormatNumber = (
  number: number | null,
  options: FormatNumberOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
) => {
  const { lang } = useLocaleStore();

  return useMemo(() => {
    if (number === null) {
      return '';
    }

    return formatNumber(number, lang, options);
  }, [
    number,
    lang,
    options.minimumFractionDigits,
    options.maximumFractionDigits,
  ]);
};
